require("./filemanager");
require("./placement");
require("./hotel");
require("./budget");
require("./search");
require("./properties");
require("./accounting");
require("./frv");

/*Reports*/
require("./reports/tps");
require("./reports/placements");
require("./reports/lead");
require("./reports/adhoc");
require("./reports/accounting");
require("./reports/hotel");
require("./reports/invoices");
require("./reports/payment-management");
require("./reports/payable");
require("./reports/vendor");
require("./reports/status");
require("./reports/properties");
require("./reports/frv");
require("./reports/on-hold");
require("./reports/time-limit");
require("./reports/qualifying-properties");
require("./reports/available-properties");
require("./reports/submitted-claims");

/*Admin*/
require("./admin/alerts");
require("./admin/clipboards");
require("./admin/cards");
require("./admin/crm");
require("./admin/event");
require("./admin/vendor");
require("./admin/company");
require("./admin/hotel");
require("./admin/contact");
require("./admin/users");
require("./admin/ip_logging");
require("./admin/loss_types");
require("./admin/maintenance");



// WEBPACK FOOTER //
// ./resources/assets/js/pages/index.js